import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-lectionary-year',
  templateUrl: './lectionary-year.component.html',
  styleUrls: ['./lectionary-year.component.css']
})
export class LectionaryYearComponent implements OnInit {

  public entities: LectionaryYear[];
  public isLoading = false;

    constructor(
      public dialog: MatDialog,
      private apiSvc: ApiService
    ) { }

    ngOnInit() {
      this.loadEntities();
    }

    private loadEntities() {
      this.isLoading = true;
      this.apiSvc.get("api/lectionaryyear", null).subscribe(
        (data: LectionaryYear[]) => {
          this.entities = data;
          console.log(this.entities);
          this.isLoading = false;
        },
        (err) => {
          console.log("error", err);
          this.isLoading = false;
        }
      );
  }

 


}


export class LectionaryYear {
  Name: string
}
